import { IContent } from '@/interfaces/lesson';
import styled, { StyledProp } from '@/styled';

import WaterMark from '../../WaterMark';

const Video = (props: IContent & StyledProp) => {
  const formatUrl = (url: string) => {
    const hasQuery = /\?.+=.*/g.test(url);
    if (hasQuery) return `${url}&transparent=0`;
    return `${url}?transparent=0`;
  };

  if (!props.drm_active) {
    return (
      <div className={props.className}>
        <iframe
          title='videoplayer'
          src={formatUrl(props.embed)}
          allowFullScreen
          allow='geolocation; microphone; camera'
        />
      </div>
    );
  }

  return (
    <WaterMark>
      <div className={props.className}>
        <iframe
          title='videoplayer'
          src={formatUrl(props.embed)}
          allowFullScreen
          allow='geolocation; microphone; camera'
        />
      </div>
    </WaterMark>
  );
};

export default styled(Video)`
  max-width: 100%;
  padding-top: 56.25%;
  position: relative;
  width: 100%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
